export let CallReceivingPreferenceType;
(function (CallReceivingPreferenceType) {
  CallReceivingPreferenceType["IN_APP"] = "IN_APP";
  CallReceivingPreferenceType["FORWARDING_NUMBER"] = "FORWARDING_NUMBER";
})(CallReceivingPreferenceType || (CallReceivingPreferenceType = {}));